import { withOData } from "@odata/withOData";
import Page, { IProps } from '@pages/Page';
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

import TableView from "../../views/table";
import { getDefinitions } from "./GrantDef";

class Grant extends Page<IProps> {
    static defaultProps = {
        usePrompt: true,
        getDef: getDefinitions,
        hasPreview: true,
        tableView: TableView
    };
}

export default withRouter(withTranslation(getDefinitions.translationFiles)(withOData(Grant)));